import Base from './base'

export default class Crm extends Base {
  getActivityFields(params: { source: string }) {
    return this.api.get('crm_activity_fields', { params })
  }
}
